<template>
  <div id="faz-virusvarianten" v-if="!loading">
    <div class="headline">Verbreitung der Virusvarianten</div>
    <p class="subheadline">Anteile ausgewählter Virusvarianten an Genom-Sequenzierungen</p>

    <select v-model="selectedCountry" class="dropdown" @change="updateData()">
      <option v-for="country in data" :key="country.name">{{country.name}}</option>
    </select>

    <div class="chart">
      <GChart
        class="gchart"
        type="AreaChart"
        :settings="{ packages: ['corechart'], language: 'de' }"
        :data="selectedData"
        :options="chartOptions"
        :resizeDebounce="0"
      />
      <!-- @ready="onChartReady" -->
    </div>
    <p class="footnote">Alpha:&nbsp;B.1.1.7 / Beta:&nbsp;B.1.351 / Delta:&nbsp;B.1.617.2 / Omikron:&nbsp;B.1.1.529<br><br>
    Die Sequenzierungen sind auf 2-Wochen-Intervalle aggregiert. Das letzte Intervall kann unvollständige Daten enthalten und sich ändern, wenn mehr Sequenzierungen eingehen. Die Sequenzierungen sind nur bedingt repräsentativ für das tatsächliche Infektionsgeschehen.<br><br>
    Stand: {{date}}<br>
    Grafik: Giesel / Quellen: GISAID, CoVariants
    <br></p>
  </div>
</template>

<script>
// import { GChart } from 'vue-google-charts'
// import pym from 'pym.js'

// const pymChild = new pym.Child()

export default {
  name: 'faz-virusvarianten',
  components: {
    // GChart
  },
  data () {
    return {
      data: null,
      selectedData: null,
      selectedCountry: "Deutschland",
      date: null,
      loading: true,
      chartOptions: {
        height: 450,
        isStacked: 'percent',
        focusTarget: 'category',
        chartArea: {left:56,top:45,width:'90%',height:'77%'},
        colors: ['#6FA746', '#EDBF57', '#ED7D38', '#D13D3D', '#D5D5D5'],
        areaOpacity: .95,
        crosshair: { 
          trigger: 'both',
          orientation: 'vertical',
          color: '#111',
          opacity: .05
        },
        fontSize: 14,
        fontName: "'FAZ Gold', Helvetica, Arial, sans-serif",
        lineWidth: .5,
        curveType: 'function',
        animation: {
          startup: false,
          duration: 500,
          easing: 'out'
        },
        hAxis: {
          textStyle: {
            color: '#666'
          },
          // minTextSpacing: 99,
          maxTextLines: 1,
          gridlines: {
            // count: 1,
            // minSpacing: 50,
            color: '#efefef'
          },
          minorGridlines: {
            // count: 0
          }
          // format: 'MMM',
          // gridlines: {
          //   count: 12,
          //   units: {
          //     days: { format: ['MM'] }
          //   }
          // },
          // minorGridlines: {
          //   count: 0
          // }

          // ticks: [],
          // textPosition: 'none'
        },
        vAxis: {
          textStyle: {
            color: '#666'
          },
          gridlines: {
            count: 5,
            color: '#111'
          },
          minorGridlines: {
            count: 0
          }
        },
        legend: {
          position: 'top',
          maxLines: 2
        },
        tooltip: {
          isHtml: true
        }
      }
    }
  },
  mounted () {
    const data_url = process.env.NODE_ENV == 'development' ? 
      'data/variants_countries.json' :
      'https://dynamic.faz.net/red/2020/coronavirus/virusvarianten/data/variants_countries.json'
      // 'https://cdn.faz-azure.com/multimediaredaktion/corona/covid_vocs/variants_countries.json?sp=r&st=2021-07-05T11:58:24Z&se=2022-07-04T22:00:00Z&spr=https&sv=2020-02-10&sr=c&sig=H%2Fx7aBxLAiZZLCIQ%2BArjzXAIiMjHNlm4ipJ9Ssg%2ByNI%3D'

    let fetches = [
      fetch(data_url).then(r => r.json()),
    ]
    Promise.all(fetches).then((results) => {
      this.data = results[0].countries
      this.date = results[0].date
      /*[0].sequencing_data /*.map( (row, index) => {
        if (index == 0) {
          return row
        } else {
          row[0] = new Date(row[0])
          return row
        }
      })*/
      this.selectedData = this.data.find( country => country.name == this.selectedCountry).sequencing_data
      this.loading = false
    })
  },
  updated () {
    // console.log("updated")
  },
  methods: {
    updateData () {
      // console.log("change")
      this.selectedData = this.data.find( country => country.name == this.selectedCountry).sequencing_data
    },
    // onChartReady (chart, google) {
    //   console.log(chart, google)
    // }
  },
  watch: {
    // selectedCountry: function () {
    //   // console.log("select")
    //   this.selectedData = this.data.find( country => country.name == this.selectedCountry).sequencing_data
    // }
  },
  computed: {
    // selectedData: function () {
    //   return this.data.find( country => country.name == this.selectedCountry).sequencing_data
    // }
  }
}
</script>

<!--style scoped src="./assets/foundation.css">
</style-->

<style scoped lang="scss">
// @import './assets/foundation.css';
@import './assets/style.scss';
</style>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

div.google-visualization-tooltip {
  border: none !important;
  padding: 4px 10px !important;
  position: absolute !important;
  color: #ffffff !important;
  font-size: 14px !important;
  line-height: 1.3 !important;
  background: #363636 !important;
  border-radius: 2px !important;
  pointer-events: none !important;
  -webkit-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;
  -moz-box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;
  box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.15) !important;

  ul {
    margin: 0 !important;
    padding: 0 !important;

    li {
      margin: 0 !important;
      padding: 0 !important;

      span {
        margin: 0 !important;
        padding: 0 !important;
        color: #fff !important;
        line-height: 1.5;
      }
    }
  }
}
.ctn-PlaceholderContent {
    overflow: visible;
}
</style>